<script lang="ts">
  export let size: 'small' | 'medium' = 'small'

  $: small = size === 'small'
  $: medium = size === 'medium'
</script>

<div class="lds-ring" class:small class:medium>
  <div />
  <div />
  <div />
  <div />
</div>

<style>
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ring.small {
    width: 36px;
    height: 36px;
  }
  .lds-ring.small div {
    width: 24px;
    height: 24px;
    border-width: 4px;
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid var(--sms-primary);
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: var(--sms-primary) transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
